// This file can be replaced during build by using the `fileReplacements` array.
// `ng build` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  appVersion: 'v8.2.4',
  USERDATA_KEY: 'authf649fc9a5f55',
  isMockEnabled: false,
  enablePermission: false,
  baseApiUrl: 'https://admin-api.useburse.com',
  apiUrl: 'api',
  firebaseConfig: {
    apiKey: "AIzaSyBNWuJAC9y8VKwtMX3cwGKhRT3hynG_pf4",
    authDomain: "eazi-test.firebaseapp.com",
    projectId: "eazi-test",
    storageBucket: "eazi-test.appspot.com",
    messagingSenderId: "20433419746",
    appId: "1:20433419746:web:04d82779c37d1feabf4dbb",
    measurementId: "G-P26EYSLY6X"
  },
};

